import React, { useEffect, useState, Fragment } from "react";
import Layout from "../../components/Layout/Layout";
import { SearchIcon } from "@heroicons/react/solid";
import { convert, formatDate, DisplayTime } from "./../../utils/convertDate";
import Paginate from "../../utils/Paginate";
import DatePicker from "react-date-picker";
import FXTransactionServices from "../../services/fxTransactions";
import Spinner from "./../../utils/Spinner";
import { DocumentDownloadIcon } from "@heroicons/react/outline";

const statusStyles = {
  Pending: "bg-amber-400 text-gray-800",
  Processing: "bg-blue-500 text-white",
  SourceAccountDebitFailed: "bg-red-600 text-white",
  SourceAccountDebited: "bg-green-500 text-white",
  DestinationAccountCreditFailed: "bg-red-600 text-white",
  DestinationAccountCredited: "bg-green-500 text-white",
  SystemException: "bg-purple-600 text-white",
};

export function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function FxTransaction() {
  const [fxTransactions, setFxTransactions] = useState([]);
  const [search, setSearch] = useState("");
  const [pageIndex, setPageIndex] = useState(1);
  const [prevPage, setPrev] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setPage] = useState(0);
  const [nextPage, setNextPage] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [fxStatus, setFxStatus] = useState("");
  const [pageLength, setPageLength] = useState("");
  const oldFrom = new Date().setDate(new Date().getDate() - 7);
  const [formValues, setFormValues] = useState({
    from: new Date(oldFrom),
    to: new Date(),
  });
  const defaultTo = formatDate(new Date());
  const longNew = formatDate(defaultTo);
  const [too, setToo] = useState(convert(longNew));
  const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7));
  const longDate = formatDate(defaultFrom);
  const [fromm, setFromm] = useState(convert(longDate));
  const [loading, setLoading] = useState(false);

  const list = async () => {
    setLoading(true);
    try {
      const resp = await FXTransactionServices.listFxTransactions(
        pageIndex,
        10,
        search,
        fromm,
        too,
        null,
        null,
        fxStatus
      );

      if (resp && resp.data) {
        setFxTransactions([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount);
        setPageIndex(resp.data.pageIndex);
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);
      } else {
        setFxTransactions([]);
        setPageLength(0);
      }
    } catch (error) {
      console.error("Error fetching FX transactions:", error);
      setFxTransactions([]);
      setPageLength(0);
    }
    setLoading(false);
  };

  const handleSort = async (status) => {
    setPageIndex(1);
    setFxStatus(status === "All" ? "" : status);
  };

  const dateValidation = {
    fromHandler: (event) => {
      setFormValues({ ...formValues, from: event });
    },
    toHandler: (event) => {
      setFormValues({ ...formValues, to: event });
    },
  };

  const range = async (e) => {
    e.preventDefault();
    const newDate = formatDate(formValues.from);
    setFrom(formValues.from);
    var longDate = formatDate(newDate);
    setFromm(convert(longDate));

    const toDate = formatDate(formValues.to);
    setTo(formValues.to);
    setToo(convert(toDate));

    await list();
  };

  const searchFx = async (text) => {
    setSearch(text);
  };

  useEffect(() => {
    list();
  }, [pageIndex, search, fxStatus, fromm, too]);

  const ExportFx = async () => {
    const resp = await FXTransactionServices.exportFxTransactionRate(
      search,
      null, null,
      fxStatus, fromm, too
    );
    window.open(resp.data);
  };

  return (
    <div>
      <Layout
        title="FX Transactions"
        pageTag={"fx_transactions"}
        current={"/transactions"}
      >
        <React.Fragment>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="mt-4 sm:mt-0 sm:ml-16 flex justify-end">
              {/* <button
                type="button"
                onClick={() => {}}
                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
              >
                <DocumentDownloadIcon className="w-4 mr-1.5" />
                Export CSV
              </button> */}
            </div>
            <div className="sm:flex sm:items-center mt-10">
              <div className="sm:flex-auto flex items-center">
                <div className="sm:flex-auto flex">
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">From</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.fromHandler}
                      value={formValues.from}
                    />
                  </div>
                </div>
                <div className=" relative rounded-md shadow-sm ml-3">
                  <p className="text-sm leading-3 text-gray-500">To</p>
                  <div>
                    <DatePicker
                      onChange={dateValidation.toHandler}
                      value={formValues.to}
                    />
                  </div>
                </div>
                <div className="flex ml-4">
                  <div className="mt-5 relative rounded-md shadow-sm">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <SearchIcon
                        className="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                      />
                    </div>
                    <input
                      type="text"
                      name="search"
                      id="search"
                      onChange={(e) => searchFx(e.target.value)}
                      className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                      placeholder="Search transactions"
                    />
                  </div>
                </div>
                <div className="mt-5 ml-4">
                  <button
                    onClick={range}
                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                  >
                    Search
                  </button>
                </div>
                <div className="mt-5 relative rounded-md shadow-sm ml-3">
                  <select
                    id="status"
                    name="status"
                    onChange={(e) => handleSort(e.target.value)}
                    className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                  >
                    <option value="All">All Status</option>
                    <option value="Pending">Pending</option>
                    <option value="Processing">Processing</option>
                    <option value="SourceAccountDebitFailed">
                      Source Debit Failed
                    </option>
                    <option value="SourceAccountDebited">Source Debited</option>
                    <option value="DestinationAccountCreditFailed">
                      Destination Credit Failed
                    </option>
                    <option value="DestinationAccountCredited">
                      Destination Credited
                    </option>
                    <option value="SystemException">System Exception</option>
                  </select>
                </div>
                </div>
                                <button
                                onClick={ExportFx}
                                    type="button"
                                    className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto h-11"
                                >
                                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                                    Export CSV
                                </button>                            
              </div>
            </div>
            {/* Transactions Table */}
            {loading ? (
              <div className="mt-8 flex justify-center">
                <Spinner />
              </div>
            ) : fxTransactions.length === 0 ? (
              <div className="mt-8 text-center">No FX transactions found</div>
            ) : (
              <>
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                      <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">
                        <table className="min-w-full table-fixed divide-y divide-gray-300 mb-24">
                          <thead className="bg-gray-50">
                            <tr>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Transaction Ref
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Source Account
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Destination Account
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Source Amount
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Destination Amount
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Exchange Rate
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Status
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Date Created
                              </th>
                              <th className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                                Time of Transaction
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200 bg-white">
                            {fxTransactions.map((transaction) => (
                              <tr key={transaction.id}>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {transaction.sourceTransactionReference}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <div className="font-medium text-gray-900">
                                    {
                                      transaction.sourceAccountDetails
                                        ?.accountName
                                    }
                                  </div>
                                  <div>
                                    {
                                      transaction.sourceAccountDetails
                                        ?.accountNumber
                                    }
                                  </div>
                                  <div>{transaction.sourceCurrency}</div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <div className="font-medium text-gray-900">
                                    {
                                      transaction.destinationAccountDetails
                                        ?.accountName
                                    }
                                  </div>
                                  <div>
                                    {
                                      transaction.destinationAccountDetails
                                        ?.accountNumber
                                    }
                                  </div>
                                  <div>{transaction.destinationCurrency}</div>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {transaction.sourceCurrency}{" "}
                                  {transaction.sourceAmount?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {transaction.destinationCurrency}{" "}
                                  {transaction.destinationAmount?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  NGN{" "}
                                  {transaction.exchangeRate?.toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  <span
                                    className={classNames(
                                      statusStyles[transaction.status] ||
                                        "bg-gray-200 text-gray-800",
                                      "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                                    )}
                                  >
                                    {transaction.status}
                                  </span>
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {formatDate(transaction.dateCreated)}
                                </td>
                                <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                  {DisplayTime(transaction.dateCreated)}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <Paginate
                  nextPage={nextPage}
                  pageIndex={pageIndex}
                  totalCount={pageNumber}
                  totalPages={totalPage}
                  prevPage={prevPage}
                  setPageIndex={setPageIndex}
                />
              </>
            )}
          </div>
        </React.Fragment>
      </Layout>
    </div>
  );
}
